import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'

import { StatsCard } from 'components'
import theme from 'theme'

const PhishingStatsCards = ({ stats }) => {
  return (
    <Grid container spacing={3} alignItems="flex-start">
      <Grid item xs={6} md={3}>
        <StatsCard
          label="Entregues"
          subLabel="e-mails enviados"
          value={stats?.delivered ?? 0}
          backgroundColor={theme.palette.dashboard.chart.phishing.delivered}
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <StatsCard
          label="Visualizados"
          subLabel="e-mails abertos"
          value={stats?.viewed ?? 0}
          backgroundColor={theme.palette.dashboard.chart.phishing.viewed}
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <StatsCard
          label="Cliques no Link"
          subLabel="acessos ao link"
          value={stats?.clicks ?? 0}
          backgroundColor={theme.palette.dashboard.chart.phishing.clicks}
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <StatsCard
          label="Comprometidos"
          subLabel="credenciais expostas"
          value={stats?.compromised ?? 0}
          backgroundColor={theme.palette.dashboard.chart.phishing.compromised}
        />
      </Grid>
    </Grid>
  )
}

PhishingStatsCards.propTypes = {
  stats: PropTypes.shape({
    delivered: PropTypes.number,
    viewed: PropTypes.number,
    clicks: PropTypes.number,
    compromised: PropTypes.number,
  }),
}

export default PhishingStatsCards
